"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterFlowTags = exports.FlowTags = void 0;

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.filter.js");

var FlowTags = {
  /**
   * These tags are defined on the backend, nicely exposed as enumerations in
   * typescript. Programmatically defining this would be amazing, but unless they
   * are listed here, they seem to be compiled out of the built code.
   */
  GOLD: 'GOLD',
  // InquiryView.TierEnum
  SILVER: 'SILVER',
  // InquiryView.TierEnum
  STANDARD: 'STANDARD',
  // InquiryView.TierEnum
  // Tags from here down are defined in the FE apps, they don't have a corresponding
  // backend database table that defines them.
  FROM_INQUIRY: 'FROM_INQUIRY',
  FROM_FAVORITE: 'FROM_FAVORITE',
  UNREAD: 'UNREAD',
  READ: 'READ',
  INVITED_TO_INQUIRE: 'INVITED_TO_INQUIRE'
};
exports.FlowTags = FlowTags;
var FlowTagKeys = Object.keys(FlowTags);

var isFlowTag = function isFlowTag(tag) {
  return FlowTagKeys.includes(tag);
};

var filterFlowTags = function filterFlowTags(tags) {
  return tags.filter(isFlowTag);
};

exports.filterFlowTags = filterFlowTags;